import { render } from "./index.vue?vue&type=template&id=a044f4a0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=a044f4a0&scoped=true&lang=scss"
import "./index.vue?vue&type=style&index=1&id=a044f4a0&lang=scss"

import exportComponent from "C:\\project\\OfficialWebsite360\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a044f4a0"]])

export default __exports__